export default {
  type: 'translatable-richtext',
  meta: {
    default_lang: 'vi'
  },
  value: '',
  translations: [
    {
      language: 'vi',
      value: ''
    }
  ]
}
